import type { FieldType, ICollection, IProjectLaborDistribution, IProjectLaborDistributionEntry } from '@/interfaces'
import { Collection, ProjectLaborDistributionEntry } from '@/models'

import { addToJSON } from './helper'
export class ProjectLaborDistribution implements IProjectLaborDistribution {
	[key: string]: FieldType
	id: number
	shop: string
	entries: ICollection<IProjectLaborDistributionEntry>
	constructor({ id, shop, entries }: Partial<IProjectLaborDistribution> = {}) {
		this.id = id || 0
		this.shop = shop || 'No shop'
		this.entries = new Collection(ProjectLaborDistributionEntry, entries || [])
		addToJSON(ProjectLaborDistribution)
	}
	get totalHours() {
		return this.entries.reduce((sum, entry) => sum + entry.hours, 0)
	}
	toJSON(): string {
		// this will be overridden by the addToJSON method
		return ''
	}
}
